import { Icon, Stack, IconButton, IContextualMenuProps, ContextualMenuItemType, Text, IContextualMenuItem } from '@fluentui/react';
import { useDrag } from '@use-gesture/react';
import { useAllRowsClosedContext } from '../../../../../_grid/contexts/allRowsClosedContext';
import { useExpandedGridContext } from '../../../../../_grid/contexts/expandedContext';
import { BORDER, TOP_HEADERS_HEIGHT } from '../../CONSTANTS';
import { useGridLayoutContext } from '../../context/LayoutContext';
import { useMemo } from 'react';
import { useTheme } from '../../../../../../../Themes/themeContext';
import { useUISettings } from '../../../../../../../context/network/http/QueryProvider/queries/UISettings';
import { ArrayEx } from '../../../../../../../Utilities/ArrayEx';
import { useGroupingContext } from '../../context/GroupingContext';
import { useTranslation } from '../../../../../../../Locales/i18n/localizationService';

export const GridHeader = ({ gridName }: { gridName: string }) => {
	const {t} = useTranslation();
    const { setExpandedRows } = useExpandedGridContext();
    const allRowsClosed = useAllRowsClosedContext();
    const { rowHeaderSize, setRowHeaderSize } = useGridLayoutContext();
    const bind = useDrag(({ down, memo, movement: [mx] }) => {
        if (!down) {
            return;
        }
        if (!memo) {
            return rowHeaderSize;
        }
        const newX = memo + mx;
        setRowHeaderSize(newX);
    }, {});

    const { grouping, setGrouping } = useGroupingContext();
    const { data: uiSettings } = useUISettings();
    const menuItems = useMemo((): IContextualMenuItem[] => {
        const menuItems: Array<IContextualMenuItem> = [];

        const groupByItems: Array<IContextualMenuItem> = [
            {
                key: 'default',
                text: t("ProjectCapacity.Default"),
                title: t("ProjectRowMenu.GroupBy.ContractDefined"),
                onClick: () => setGrouping(null),
                disabled: grouping === null,
            },
            {
                key: 'rbs',
                text: t("Common.Rbs"),
                title: t("ProjectRowMenu.GroupBy.ResourceRBS"),
                onClick: () => setGrouping('RBS'),
                disabled: grouping === 'RBS',
            },
            {
                key: 'workpackage',
                text: t("Common.WorkPackage"),
                title: t("ProjectRowMenu.GroupBy.WorkPackage"),
                onClick: () => setGrouping('WorkPackage'),
                disabled: grouping === 'WorkPackage',
            },
        ];

        if (uiSettings.settings.enableWorkPackages) {
            groupByItems.push({
                key: 'requesttemplate',
                text: t("ProjectCapacity.RequestTemplate"),
                title: t("ProjectRowMenu.GroupBy.OriginatedRequestTemplate"),
                onClick: () => setGrouping('RequestTemplate'),
                disabled: grouping === 'RequestTemplate',
            });
        }

        if (!ArrayEx.isNullOrEmpty(uiSettings.settings.resourceCustomProperties)) {
            groupByItems.push({
                key: 'custom',
                text: 'Custom Properties',
                title: t("ProjectRowMenu.CustomProperties"),
                itemType: ContextualMenuItemType.Header,
            });
            uiSettings.settings.resourceCustomProperties.forEach(_ => {
                groupByItems.push({
                    key: _.id,
                    text: _.displayName,
                    title:  t("ProjectRowMenu.ResourceCustomProperty", { displayname: _.displayName }),
                    onClick: () => setGrouping(`CustomProperties.${_.id}`),
                    disabled: grouping === `CustomProperties.${_.id}`,
                });
            });
        }

        if (uiSettings.settings.enableAlignContract) {
            groupByItems.push({
                key: 'align',
                text: 'Align Status',
                title: t("ProjectRowMenu.GroupBy.AlignStatus"),
                onClick: () => setGrouping('AlignStatus'),
                disabled: grouping === 'AlignStatus',
            });
        }

        // menuItems.push({
        //     key: 'groupby',
        //     text: language.ProjectRowMenu.GroupContractsText,
        //     title: language.ProjectRowMenu.GroupContractsTitle,
        //     iconProps: { iconName: 'GroupList' },
        //     subMenuProps: {
        //         // items: groupByItems,
        //         items: groupByItems.map(item => {
        //             return {
        //                 ...item,
        //                 iconProps: { iconName: item.disabled && 'CheckMark' },
        //             };
        //         }),
        //     },
        // });

        if (uiSettings.settings.enableToggleHideGenericResource) {
            // menuItems.push({
            //     key: 'hideGenericResources',
            //     // onRender: (item: any, dismissMenu: (ev?: any, dismissAll?: boolean) => void) => (
            //     //     <RenderHideGenericResourceToggle item={item} dismissMenu={dismissMenu} />
            //     // ),
            // });
        }

        if (uiSettings.settings.enableFastDelete) {
            // menuItems.push({
            //     key: 'enableFastDelete',
            //     // onRender: (item: any, dismissMenu: (ev?: any, dismissAll?: boolean) => void) => <RenderFastDeletionToggle />,
            // });
        }
        // if (uiSettings.settings.enableScenarios && uiSettings.settings.scenarioTypesEnabled?.indexOf(ScenarioType.ProjectScenario) >= 0) {
        //     const versionItems = [];

        //     if (checkPermissions({ userTypes: [...(uiSettings.settings.userTypesAllowedToCreateScenarios ?? [])], some: true }))
        //         versionItems.push({
        //             key: 'drafts',
        //             text: language.ProjectCapacity.WorkWithDrafts, // + " (temp disabled)",
        //             title: language.ProjectCapacity.WorkWithDrafts,
        //             iconProps: { iconName: 'DoubleColumnEdit' },
        //             // onClick: (ev, item) => setShowDraftDialog(true),
        //         } as IContextualMenuItem);
        //     if (checkPermissions({ userTypes: [...(uiSettings.settings.userTypesAllowedToApproveScenarios ?? [])], some: true }))
        //         versionItems.push({
        //             key: 'versions',
        //             text: language.ProjectCapacity.CompareScenarios,
        //             title: language.ProjectCapacity.CompareScenarios,
        //             iconProps: { iconName: 'Compare' },
        //             // onClick: (ev, item) => setShowVersionsDialog(true),
        //         });

        //     // add menu item if any sub items
        //     if (versionItems.length) {
        //         menuItems.push({
        //             key: 'scenario',
        //             text: language.ProjectCapacity.MenuItems.Scenario.Text,
        //             title: language.ProjectCapacity.MenuItems.Scenario.Title,
        //             iconProps: { iconName: 'MultiSelect' },
        //             subMenuProps: {
        //                 items: versionItems,
        //             },
        //         });
        //     }
        // }

        // if (uiSettings.settings.enableProjectExportRefresh && checkPermissions({ userTypes: [UserType.SuperUser] })) {
        //     menuItems.push({
        //         key: 'refreshexport',
        //         text: language.ProjectCapacity.MenuItems.RefreshExport.Text,
        //         title: language.ProjectCapacity.MenuItems.RefreshExport.Title,
        //         iconProps: { iconName: 'AnalyticsReport' },
        //         onClick: (ev, item) => {
        //             // refreshProjectReportData();
        //         },
        //     });
        // }

        return menuItems;
    }, [
        grouping,
        setGrouping,
        uiSettings.settings.enableAlignContract,
        uiSettings.settings.enableFastDelete,
        uiSettings.settings.enableToggleHideGenericResource,
        uiSettings.settings.enableWorkPackages,
        uiSettings.settings.resourceCustomProperties,
		t
    ]);

    const menuProps = useMemo((): IContextualMenuProps => {
        return {
            items: [
                {
                    key: 'gridSettings',
                    itemType: ContextualMenuItemType.Section,
                    sectionProps: {
                        bottomDivider: true,
                        title: t("GridSettings.GridSettings"),
                        items: [
                            {
                                key: 'showPersona',
                                onRender: () => <RenderPersonaToggle />,
                            },
                            ...menuItems,
                        ],
                    },
                },
            ],
        };
    }, [menuItems, t]);

    return (
        <div
            style={{
                background: 'white',
                borderBottom: BORDER,
                borderRight: BORDER,
                boxSizing: 'border-box',
                zIndex: 2,
                width: `${rowHeaderSize}px`,
                height: TOP_HEADERS_HEIGHT,
                position: 'sticky',
                left: 0,
                display: 'flex',
            }}
        >
            <Stack horizontal horizontalAlign="space-between" verticalAlign="end" styles={{ root: { width: '100%', paddingBottom: 10 } }}>
                <Stack styles={{ root: { height: '100%' } }}>
                    <span className="tp-capacity-project-title">
                        <div className="truncate-text">{gridName}</div>
                    </span>

                    <Stack horizontal>
                        <IconButton
                            iconProps={{ iconName: 'CalculatorAddition' }}
                            title="Expand all"
                            onClick={() => {
                                setExpandedRows(expanded => {
                                    return Object.fromEntries(Object.keys(expanded).map(key => [key, true]));
                                });
                            }}
                        />
                        <IconButton
                            iconProps={{ iconName: 'CalculatorSubtract' }}
                            title="Collapse all"
                            disabled={allRowsClosed}
                            onClick={() => {
                                setExpandedRows(expanded => {
                                    return Object.fromEntries(Object.keys(expanded).map(key => [key, false]));
                                });
                            }}
                        />
                    </Stack>
                </Stack>
                <IconButton menuIconProps={{ iconName: 'Settings' }} menuProps={menuProps} styles={{ menuIcon: { fontSize: 16 } }} />
            </Stack>
            <Stack
                {...bind()}
                verticalAlign="center"
                horizontalAlign="end"
                styles={{
                    root: {
                        '& > div': {
                            opacity: 0,
                            transition: '.3s ease',
                            userSelect: 'none',
                        },
                        '&:hover > div': {
                            opacity: 1,
                        },
                        touchAction: 'none',
                        width: 50,
                        cursor: 'col-resize',
                        paddingRight: 5,
                    },
                }}
            >
                <div>
                    <Icon iconName="ImportMirrored" title="Resize resource column" />
                </div>
            </Stack>
        </div>
    );
};

const RenderPersonaToggle = () => {
	const {t} = useTranslation();
    const { hidePersonaIcons, setHidePersonaIcons } = useGridLayoutContext();
    const theme = useTheme();

    return (
        <Text
            onClick={() => {
                setHidePersonaIcons(s => !s);
            }}
            styles={{
                root: {
                    ...buttonRootStyles,
                    '&:hover': {
                        backgroundColor: theme.semanticColors.buttonBackgroundHovered,
                    },
                },
            }}
        >
            <Icon
                iconName="ContactInfo"
                styles={{
                    root: {
                        paddingTop: 2,
                        marginRight: 8,
                        marginLeft: 4,
                        color: theme.semanticColors.menuIcon,
                        fontSize: 16,
                    },
                }}
            />
            {hidePersonaIcons ? t("GridSettings.ShowPersona") : t("GridSettings.HidePersona")}
        </Text>
    );
};

const buttonRootStyles = {
    display: 'flex',
    alignItems: 'center',
    height: 36,
    width: '100%',
    padding: '0 4px',
    cursor: 'pointer',
    userSelect: 'none',
};
